import { FC } from "react";

import { useGetLimitQuery } from "../../../../api/limit";
import { useGetProfileQuery } from "../../../../api/profile";
import { useGetCoolingInfoQuery } from "../../../../api/cooling";
import { LimitStatus, LimitStatusType } from "../../../../api/limit/types";
import { MainPagePending } from "./MainPagePending";
import { MainPageSbpTransfer } from "../SbpTransfer";
import { MainPageCoolingPeriod } from "../CoolingPeriod";
import { MainPageLimitError } from "./MainPageLimitError";
import { MainPageAvailableLimit } from "../AvailableLimit";
import { MainPageLimitClosed } from "./MainPageLimitClosed";
import { MainPagePaymentSchedule } from "../PaymentSchedule";
import { MainPageCoolingError } from "./MainPageCoolingError";
import { MainPageOperationHistory } from "../OperationHistory";

export const MainPageContent: FC = () => {
  const { isPending: isProfilePending } = useGetProfileQuery(); // need for unleash white-list
  const {
    data: limit,
    isPending: isLimitPending,
    isError: isLimitError,
    error: limitError,
    refetch: limitRefetch,
  } = useGetLimitQuery();

  const {
    data: cooling,
    isPending: isCoolingPending,
    isFetching: isCoolingFetching,
    isError: isCoolingError,
    error: coolingError,
    refetch: coolingRefetch,
  } = useGetCoolingInfoQuery();

  const showLimitError = (isLimitError && !limit) || !LimitStatus.includes(limit?.status as unknown as LimitStatusType);
  const showCoolingError = (isCoolingError && !cooling) || typeof cooling?.isLimitCooldown !== "boolean";

  if (isLimitPending || isCoolingPending || isProfilePending) {
    return <MainPagePending />;
  }

  if (showLimitError) {
    return <MainPageLimitError error={limitError} refetch={limitRefetch} />;
  }

  if (limit.status === "CLOSED") {
    return <MainPageLimitClosed />;
  }

  return (
    <>
      <MainPageAvailableLimit />

      {showCoolingError
        ? <MainPageCoolingError error={coolingError} refetch={coolingRefetch} />
        : (
          <>
            <MainPageCoolingPeriod isActive={cooling.isLimitCooldown} finishedAt={cooling.limitInfo?.cooldownEndDateTime} />
            <MainPagePaymentSchedule />
            <MainPageSbpTransfer limitStatus={limit.status} isCoolingFetching={isCoolingFetching} isCoolingActive={cooling.isLimitCooldown} />
            <MainPageOperationHistory />
            {/* <QRButton /> #Feature on hold */}
          </>
          )}
    </>
  );
};
